import { NotificationsActive } from '@mui/icons-material';
import {
  Button,
  FormControl,
  MenuItem,
  Select,
  Typography,
} from '@mui/material';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { useEmailNotificationCard } from '~/scenes/PortalModules/User/UserSettings/components/EmailNotificationCard/useEmailNotificationCard';
import { UserSettingsCard } from '~/scenes/PortalModules/User/UserSettings/components/UserSettingsCard';
import { getEnumName } from '~/utils/helpers/enum';

export const EmailNotificationCard = () => {
  const { t } = useTranslation();

  const {
    isLocked,
    isLoading,
    form: {
      control,
      formState: { isDirty },
    },
    frequencyOptions,
    editMode,
    onEdit,
    onCancelEdit,
    onSubmit,
  } = useEmailNotificationCard();

  if (isLocked) {
    return null;
  }

  return (
    <UserSettingsCard
      Icon={NotificationsActive}
      title={t('laNotificationEmail')}
      loading={isLoading}
      actions={
        editMode ? (
          <>
            <Button size="small" onClick={onCancelEdit}>
              {t('laCancel')}
            </Button>
            <Button
              size="small"
              variant="contained"
              onClick={onSubmit}
              disabled={!isDirty}
            >
              {t('laSave')}
            </Button>
          </>
        ) : (
          <Button size="small" onClick={onEdit}>
            {t('laEdit')}
          </Button>
        )
      }
    >
      <Controller
        control={control}
        name={'frequency'}
        render={({ field: { value, onChange } }) => {
          return editMode ? (
            <FormControl fullWidth size="small">
              <Select value={value} onChange={onChange}>
                {frequencyOptions.map((option) => (
                  <MenuItem key={option.code} value={option.code}>
                    {option.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          ) : (
            <Typography variant={'body2'}>
              {getEnumName(frequencyOptions, value)}
            </Typography>
          );
        }}
      />
    </UserSettingsCard>
  );
};
